// Dependencies
import React, { Component } from 'react';
import { Document, Page, pdfjs } from "react-pdf";
import PageTitleComponent from '../../components/page-title/page-title';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Primereact imports
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

// Styling
import './meeting-notes.scss';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Redux
import CmsService from '../../redux/services/cms';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class MeetingNotesPage extends Component {

    constructor(props) {    
        super(props);
        this._toast = React.createRef();
        this.state = {
            meetingList: [],
            selectedFile: null,
            selectedPDF: null,
            numPages: null,
            pageNumber: 1
        };
    }

    componentDidMount() {
        CmsService.getMeetingNoteList()
        .then((response) => {
            let meetingList = [];

            for (let i = 0; i < response.files.length; i++) {
                meetingList.push({
                    code: response.files[i].fileIdentifier,
                    name: response.files[i].name.split("-")[1].replace(".pdf", "")
                })
            }

            this.setState({
                meetingList: meetingList
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("content.atas.messages.error"), life: 3000 });
        });
    }

    selectPDFToRender(file) {
        this.setState({ 
            selectedFile: file,
            numPages: null,
            pageNumber: 1
        });

        CmsService.getMeetingNotePageContent(file.code)
        .then((response) => {
            const byteCharacters = atob(response.fileContent);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            this.setState({
                selectedPDF: new Blob([byteArray], {type: response.contentType})
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("content.atas.messages.error"), life: 3000 });
        });
    }

    goToPrevPage() {
        if(this.state.pageNumber !== 1) {
            this.setState({pageNumber: this.state.pageNumber - 1});
        }
    }

    goToNextPage() {
        if(this.state.pageNumber !== this.state.numPages) {
            this.setState({pageNumber: this.state.pageNumber + 1});
        }
    }

    render() {
       return (
            <div>
                <PageTitleComponent title={this.props.t("content.atas.title")} />
                <div className='grid mgb-80 mgt-20'>
                    <div className='col-12 t-align-center'>
                        <span>{this.props.t("content.atas.messages.choose-ata")}</span>
                        <Dropdown className='mgl-10' value={this.state.selectedFile} id="meeting-note-file" options={this.state.meetingList} optionLabel="name" onChange={(evt) => this.selectPDFToRender(evt.value)}></Dropdown>
                    </div>
                    <div className='col-4'></div>
                    <div className='col-1 t-align-left'>
                        {
                            this.state.selectedPDF !== null ?
                                <Button className='p-button-info' label={this.props.t("content.general.messages.previous")} onClick={() => this.goToPrevPage()} />
                                : null
                        }
                    </div>
                    <div className='col-2 t-align-center'>
                        {
                            this.state.selectedPDF !== null ?
                                <p style={{marginTop:"10px"}}>{this.props.t("content.general.messages.page")} {this.state.pageNumber} {this.props.t("content.general.messages.from")} {this.state.numPages}</p>
                                : null
                        }
                    </div>
                    <div className='col-1 t-align-right'>
                        {
                            this.state.selectedPDF !== null ?
                                <Button className='p-button-info' label={this.props.t("content.general.messages.next")} onClick={() => this.goToNextPage()} />
                                : null
                        }
                    </div>
                    <div className='col-4'></div>
                    <div className='col-4'></div>
                    <div className='col-4'>
                        {
                            this.state.selectedPDF !== null ?
                                <Document
                                    file={this.state.selectedPDF}
                                    onContextMenu={(e) => e.preventDefault()}
                                    onLoadSuccess={({ numPages })=>this.setState({numPages: numPages})}
                                    pageLayout="twoPageLeft"
                                    pageMode="fullScreen"
                                    className="pdf-container">
                                        <Page pageNumber={this.state.pageNumber} />
                                </Document>
                                : null
                        }
                    </div>
                    <div className='col-4'></div>
                    <Toast position='bottom-left' ref={this._toast} />
                </div>
            </div>
        );
    }
}

export default authenticationChecker(withTranslation(MeetingNotesPage));